export default {
  path: 'occupations',
  name: 'PersonOccupations',
  component: () => import(/* webpackChunkName: "people" */ '../views/PersonOccupationView.vue')
}
